module.exports = "https://img1.zhuanstatic.com/platform/zz-universal-pages/static/img/wrong.2a3cb0ed.png";